import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { CrmAccountEntity } from '../../../../api/types/crm/accounts/crm-account-entity';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const getCrmAccountsListOperation = async (
  offset: number,
  limit: number,
  filters: {
    accountName?: string | null;
    accountTypes: string[];
  },
  setData: (data: CrmAccountEntity[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getCrmAccountsList({
      offset,
      limit,
      accountName: filters?.accountName ?? '',
      accountTypes: filters?.accountTypes ?? [],
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const paginationResponse = res.data.body;

    if (!paginationResponse || !Array.isArray(paginationResponse.data)) {
      console.error(
        'Invalid data in crm accounts response:',
        paginationResponse,
      );
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setData(paginationResponse.data);
    setTotal(paginationResponse.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
